import { FC } from 'react';
import type { UserNotification } from 'state/notifications/notification.model';
import styled from 'styled-components';

import { Notification } from './Notification';

type NotificationListProps = Readonly<{
  notifications: UserNotification[];
  onClose: (id: string) => void;
}>;

const StyledDiv = styled.div`
  position: fixed;
  right: 20px;
  top: 150px;
  z-index: 10000 !important;
`;

export const NotificationListComponent: FC<NotificationListProps> = ({ notifications, onClose }) => {
  return (
    <StyledDiv>
      {notifications.map(({ id, level, title, content, details, closeAutomatically, minWidth }) => (
        <Notification
          key={id}
          id={id}
          level={level}
          title={title}
          content={content}
          details={details}
          closeAutomatically={closeAutomatically}
          onDismiss={onClose}
          minWidth={minWidth}
        />
      ))}
    </StyledDiv>
  );
};
